import adserver from 'services/adserver';
import { proposalsKeys } from './proposals.keys';
import { Proposal } from './proposals.types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { normalizeApiResponse } from './proposals.helpers';

const getProposalById = async (id: number): Promise<Proposal> => {
  const response = await adserver({
    url: `/proposal/${id}`,
    headers: {},
  });
  const surcharges = await adserver({
    url: `/proposal/${id}/surcharges`,
    headers: {},
  });
  const proposal = normalizeApiResponse(response.data);
  return {
    ...proposal,
    surcharges: surcharges?.data,
  };
};

export const useGetProposalById = <TData = Proposal>(
  id: number,
  select?: (data: Proposal) => TData,
): UseQueryResult<TData, unknown> => {
  const result = useQuery({
    queryKey: proposalsKeys.detail(id),
    queryFn: () => getProposalById(id),
    enabled: !!id,
    select,
  });

  return result;
};
